import { Component, OnInit, TemplateRef } from '@angular/core';
import * as numeral from 'numeral';
import { Retencion } from '../../../models/retencion';
import { RetencionService } from '../../../services/retencion.service';
import { RetencionCompraModalComponent } from '../../../components/modals/retencion-compra-modal/retencion-compra-modal.component';
import { ReenviarCorreoComponent } from '../../../components/modals/reenviar-correo/reenviar-correo.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import { ConfigService } from '../../../config/config-service';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { CompraModalComponent } from '../../modals/compra-modal/compra-modal.component';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
	selector: 'retenciones-compra-list',
	templateUrl: './retenciones-compra-list.component.html',
	styleUrls: ['./retenciones-compra-list.component.css'],
	providers: [RetencionService]
})
export class RetencionesCompraListComponent implements OnInit {
	public retenciones: Array<Retencion>;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public loading = false;
	public msg: SweetMessage;
	public config: ConfigService;
	public Mod_FactElec: string;
	public retencion_anulada: Retencion;
	public observacion: String;
	public total: number;
	public total_activas: number;
	public total_anuladas: number;
	public factelec_api: String;
	
	constructor(
		public retencionService: RetencionService,
		private modalService: BsModalService,
		private ss: SessionService,
	) {
		this.msg = new SweetMessage();
		this.retenciones = [];
		this.config = new ConfigService();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.retencion_anulada = new Retencion();
		this.observacion = "";
		this.factelec_api = environment.factelec_api;
	}

	ngOnInit() {
		this.loading = true;
		this.getRetenciones().then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

	getRetenciones(){
		return new Promise((resolve, reject) => {
			let now = moment();							
			this.retencionService.getAll("?tipo=C&fecha_emision=" + moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format() + "&embed=detalle,estadobitacora,asientocontable,tipocomprobante,compra?embed=proveedor&sort=-fecha_emision,-secuencial&usuario_id="+this.ss.getData('usuario_id')).subscribe(
				res => {
					this.retenciones = res.data;
					this.total = 0;
					this.total_anuladas = 0;
					this.total_activas = 0;

					this.retenciones.forEach(x => {
						this.total += parseFloat(x.total.toString());
						x.detalle.forEach( d=>{
							if(d.impuesto_id == '1'){
								x.total_renta += d.total;
							}
							if(d.impuesto_id == '2'){
								x.total_iva += d.total;
							}
						});
						if( x.status === 'I' ) this.total_anuladas += parseFloat(x.total.toString());
						if( x.status === 'A' ) this.total_activas += parseFloat(x.total.toString());
					});
					resolve();
				},
				err => {
					this.retenciones = [];
					reject();
				}
			);
		});
	}

	getNumeroDocumento(retencion){
		return retencion.serie + "-" + retencion.punto_emision + "-" + retencion.secuencial;
	}

	onShow(id){
		const initialState = {retencion_id: id};
		this.bsModalRef = this.modalService.show(RetencionCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onShowFactura(compra_id){
		const initialState = {compra_id: compra_id};
		this.bsModalRef = this.modalService.show(CompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}

	onStatusElectronica(retencion){
		let msn = "";
		msn += "<p>Estado de Retención Electrónica</p>";
        msn += "<p><b style='font-size:24px;'>"+retencion.estadobitacora.descripcion+"</b></p>";
    
        this.msg.showMessage('single-message', msn);
	}

	OnReenviar1(retencion){
		this.msg.showMessage('delete-confirm-message',"Está seguro de reenviar el correo al cliente: <br /> <b>" + retencion.compra.proveedor.nombre_comercial + "<b> <br /> <b>" + retencion.compra.proveedor.correo + "</b>").then(
			res => {
				if(res == "ok"){
					retencion.enviando = true;
					let data = {
						"clave": retencion.numero_autorizacion,
						"usuario_id": this.ss.getData('facelect_usuario_id')
					};
					this.retencionService.ReenviarElectronica(data).subscribe(
						res => {
							retencion.enviando = false;
						},
						err => {
							retencion.enviando = false;
						}
					);
				}
			}
		);
	}

	OnReenviar(retencion){
        const initialState = { nombre: retencion.compra.proveedor.nombre_comercial, correo: retencion.compra.proveedor.correo, autorizacion: retencion.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }

	openModalObservacion(template: TemplateRef<any>, retencion: Retencion) {
		if( retencion.status === 'A' && this.isAnulable(retencion) ){
			if(retencion.tipo_comprobante_id.toString() === "5"){
				let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
				const initialState = { Pregunta: preg, Respuesta:false };
				this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
				
				this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
					if(Respuesta == true){
						this.observacion = retencion.observacion;
						this.retencion_anulada = retencion;
						this.bsModalRef = this.modalService.show(template);
						this.bsModalRef2 = this.bsModalRef;
					}
				});
			}
			else{
				this.observacion = retencion.observacion;
				this.retencion_anulada = retencion;
				this.bsModalRef = this.modalService.show(template);
				this.bsModalRef2 = this.bsModalRef;
			}
		}
	}

	anularRetencion(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.retencion_anulada.observacion = this.observacion.toString().trim();
				this.retencion_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.retencionService.anular(this.retencion_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.retencion_anulada = new Retencion();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getRetenciones().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	onReport(retencion){
		if(this.CodEst(retencion) === 'btn-success'){
			const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + retencion.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}

	onXML(retencion){
		if(this.CodEst(retencion) === 'btn-success'){
			const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + retencion.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}

	CodEst(retencion){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === retencion.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === retencion.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === retencion.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	isAnulable(retencion: Retencion){

		return true;

        /*let f = moment();
        let fecha = f.format("YYYY") + "-" + f.format("MM") + "-01";
        let fecha_inicio = moment(fecha,"YYYY-MM_DD").format('YYYY-MM-DD');
        let fecha_fin = moment().endOf('month').format('YYYY-MM-DD');
        let fecha_emision = moment(retencion.fecha_emision.toString(),"YYYY-MM_DD");

        return fecha_emision.isSameOrAfter(fecha_inicio) && fecha_emision.isSameOrBefore(fecha_fin)*/
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/retenciones-compra-list/retenciones-compra-list.component.ts